const initState = {
    response: [],
  };
  
  export default initState;